import { render, staticRenderFns } from "./Subtitulo.vue?vue&type=template&id=44f8c955&scoped=true&"
import script from "./Subtitulo.vue?vue&type=script&lang=js&"
export * from "./Subtitulo.vue?vue&type=script&lang=js&"
import style0 from "./Subtitulo.vue?vue&type=style&index=0&id=44f8c955&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "44f8c955",
  null
  
)

export default component.exports